import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React from "react";
import PageHeader from "./components/header";
import CanvasGenerator from "./components/canvas-generator";

const SpotifyCanvasGenerator = () => {
  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Overview", link: "/overview" }}
          current="Spotify Canvas Generator"
        />
        <PageHeader />
        <CanvasGenerator />
      </>
    </DashboardLayout>
  );
};

export default SpotifyCanvasGenerator;
